import { GenericErrorResponse } from "app/api/types";
import { AxiosError } from "axios";

interface OptionsProps {
  useErrorResponse?: boolean;
}

const parseError = <T extends GenericErrorResponse>(
  error: AxiosError<T | GenericErrorResponse>,
  options: OptionsProps = { useErrorResponse: false }
) => {
  const DEFAULT_MESSAGE = "An error occurred. Please try again.";

  if (error.response) {
    const errorObj = error.response.data as any;

    if (!errorObj) return DEFAULT_MESSAGE;

    if (errorObj.error?.name === "request_validation") {
      const fields = errorObj.fields;
      if (fields && typeof fields === "object") {
        const fieldMessages = Object.entries(fields)
          .map(([field, errors]) => {
            const reasons = (errors as any[]).map((e) => e.reason).join(", ");
            return `${field}: ${reasons}`;
          })
          .join("; ");
        return fieldMessages || errorObj.error.message || DEFAULT_MESSAGE;
      }
      return errorObj.error.message || DEFAULT_MESSAGE;
    }

    if (errorObj.message) return errorObj.message;
    if (options.useErrorResponse && errorObj.error) return errorObj.error;
    if (errorObj.error?.message) return errorObj.error.message;

    return DEFAULT_MESSAGE;
  } else if (error.request) {
    return "No response from server. Please check your connection.";
  } else {
    return error.message || DEFAULT_MESSAGE;
  }
};

export default parseError